import { DefaultStore } from "@softline/core";
import {Kunde} from '../types/kunde';

export const KundenanlageTemplateStore = DefaultStore.create<Required<Kunde>>()
